const strings = {
  errors: {
    featureFlagInitFailure:
      'Some beta features may not be enabled. Please refresh if a feature you need is missing. Contact support if this persists.',
  },
};

export default strings;
